const translations = {
    noClientsFound: 'No clients found.',
    search: 'Search'
};

export default translations;
